import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { M8LegalRequesites } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idUser: number;
};

export const getUserLegalRequisites = async (
  params: Params
): Promise<null | M8LegalRequesites> => {
  const response = await customFetch(
    getM8AdminURL(`getUserLegalRequisites?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
